import React from 'react';

const MarshallTheme = {
  headerLogo: {
    src: '/themes/theme/marshall/logo.png',
    alt: 'Marshall Logo',
  },
  darkLogo: {
    src: '/themes/theme/marshall/logo.png',
    alt: 'Marshall Logo',
  },
  headerStyle: {
    backgroundColor: '#fff',
    borderBottom: '2px solid #000',
  },
  linkStyle: {
    color: '#000',
    fontWeight: 800,
    fontSize: '120%',
  },
  isLightOnDark: false,
  loginMessage: (
    <div style={{ padding: '10px' }}>
      <br /><br />
      <img height="120" src="/themes/theme/marshall/marshall_logo_120px.png" alt="Marshall Logo" />
      <br /><br />
      <h3>Marshall Influencers</h3>
    </div>
  ),
  shareSite: 'https://marshallr.dyzio.co',
};

export default MarshallTheme;



/** WEBPACK FOOTER **
 ** ./src/themes/theme/marshall.js
 **/